module.exports = __webpack_public_path__ + "assets/img/29-s.1f04b1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/29-s.jpg
// module id = adRU
// module chunks = 0